<div class="container-fluid py-4">
  <!-- <h4 class="h4">(Personnel)</h4> 
  <br /><br /><br />-->
  <div class="row justify-content-center">
    <div
      class="col-4 col-md-2"
      *ngFor="let card of resumenCardsTwo; index as i"
    >
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 1 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-5">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Campo de búsqueda mejorado con autocompletado -->
  <div class="row mb-3">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterInfo()"
          list="suggestions"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestions">
          <option
            *ngFor="let sugerencia of sugerenciasBusqueda"
            [value]="sugerencia"
          ></option>
        </datalist>
      </div>
    </div>
  </div>
  <div class="card-tools">
    <a
      [routerLink]="['/numbers/accounting']"
      class="btn btn-dark btn-sm btn-new"
      [ngClass]="{ 'btn-selected': step === 1 }"
    >
      Staff
    </a>
    <a
      [routerLink]="['/numbers/accounting/freelancers']"
      class="btn btn-dark btn-sm btn-new"
      [ngClass]="{ 'btn-selected': step === 2 }"
    >
      Freelancers
    </a>
    <a
      [routerLink]="['/numbers/accounting/drivers']"
      class="btn btn-dark btn-sm btn-new"
      [ngClass]="{ 'btn-selected': step === 3 }"
    >
      Driver & +
    </a>
    <a
      [routerLink]="['/numbers/accounting/customers']"
      class="btn btn-dark btn-sm btn-new"
      [ngClass]="{ 'btn-selected': step === 4 }"
    >
      Customers
    </a>
    <!-- <a
      [routerLink]="['/numbers/accounting/quickbooks/expenses']"
      class="btn btn-dark btn-sm btn-new"
    >
      Bills
    </a> -->
    <a
      [routerLink]="['/numbers/accounting/external']"
      class="btn btn-dark btn-sm btn-new"
    >
      Bills
    </a>
    <!--  <a
      (click)="auth()"
      class="btn btn-dark btn-sm btn-new"
    >
      auth
    </a> -->
  </div>
  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Employee Name</th>
              <th *ngIf="step == 4">Business Name</th>
              <th>Email</th>
              <!-- <th *ngIf="step == 1">Salary</th>
              <th *ngIf="step == 2">Balance</th> -->
              <!-- <th>Status</th>
              <th>Actions</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td>
                <a
                  *ngIf="step == 1"
                  [routerLink]="['/numbers/accounting/personnel/edit', item._id]"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ item.firstname }} {{ item.lastname }}</a
                >
                <a
                  *ngIf="step == 2"
                  [routerLink]="['/numbers/accounting/freelancers/edit', item._id]"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ item.firstname }} {{ item.lastname }}</a
                >
                <a
                  *ngIf="step == 3"
                  [routerLink]="['/numbers/accounting/drivers/edit', item._id]"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ item.firstname }} {{ item.lastname }}</a
                >
                <a
                  *ngIf="step == 4"
                  [routerLink]="['/customers/edit', item._id]"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ item.firstname }} {{ item.lastname }}</a
                >
              </td>
              <!-- <td>{{ item.firstname }}</td> -->
              <!-- <td>{{ item.lastname }}</td> -->
              <th *ngIf="step == 4">{{ item.business_name || "NO" }}</th>
              <td>{{ item.username }}</td>
              <!-- <td>{{ item.displaySalary }}</td> -->
              <!--  <td>
                <span
                  class="badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </span>
              </td>
              <td>
                <a
                  [routerLink]="['/numbers/accounting/personnel/edit', item._id]"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-edit"></i>
                </a> -->
              <!--  <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-trash"></i>
                </button> -->
              <!-- </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
